export default __webpack_public_path__ + "static/media/redDick.93998a78.png";